export default __webpack_public_path__ + "static/media/img1.fc7fb399.png";